// Dubai Metro station master list — updated to current RTA station names
// (2024-2026 including recent naming-rights renames). Blue Line intentionally
// excluded because it opens in 2029 — not walkable today.
// Coords are approximate corridor waypoints from public RTA data; sufficient
// for a "N min walk" convenience badge on listing detail pages.

export const METRO_STATIONS = [
  // ── Red Line (Centrepoint → Expo City / UAE Exchange) ────────────────
  { name: "Centrepoint", line: "red", lat: 25.2732, lng: 55.4058 },
  { name: "Emirates", line: "red", lat: 25.2680, lng: 55.3898 },
  { name: "Airport Terminal 3", line: "red", lat: 25.2610, lng: 55.3808 },
  { name: "Airport Terminal 1", line: "red", lat: 25.2555, lng: 55.3720 },
  { name: "GGICO", line: "red", lat: 25.2530, lng: 55.3620 },
  { name: "Deira City Centre", line: "red", lat: 25.2530, lng: 55.3555 },
  { name: "Al Rigga", line: "red", lat: 25.2585, lng: 55.3300 },
  { name: "Union", line: "red", lat: 25.2540, lng: 55.3300 },
  { name: "BurJuman", line: "red", lat: 25.2528, lng: 55.3320 },
  { name: "ADCB", line: "red", lat: 25.2445, lng: 55.3110 },
  { name: "Max", line: "red", lat: 25.2410, lng: 55.3070 }, // formerly Al Jafiliya (renamed 2024)
  { name: "World Trade Centre", line: "red", lat: 25.2298, lng: 55.3060 },
  { name: "Emirates Towers", line: "red", lat: 25.2210, lng: 55.2830 },
  { name: "Financial Centre", line: "red", lat: 25.2170, lng: 55.2750 },
  { name: "Burj Khalifa / Dubai Mall", line: "red", lat: 25.2110, lng: 55.2695 },
  { name: "Business Bay", line: "red", lat: 25.2000, lng: 55.2620 },
  { name: "Onpassive", line: "red", lat: 25.1867, lng: 55.2504 },      // formerly Noor Bank
  { name: "Equiti", line: "red", lat: 25.1750, lng: 55.2410 },          // formerly First Abu Dhabi Bank
  { name: "Mall of the Emirates", line: "red", lat: 25.1700, lng: 55.2380 },
  { name: "Sharaf DG", line: "red", lat: 25.1610, lng: 55.2270 },
  { name: "Dubai Internet City", line: "red", lat: 25.1050, lng: 55.1740 },
  { name: "Nakheel", line: "red", lat: 25.0930, lng: 55.1610 },
  { name: "DAMAC Properties", line: "red", lat: 25.0850, lng: 55.1520 },
  { name: "Jumeirah Lakes Towers", line: "red", lat: 25.0700, lng: 55.1400 },
  { name: "Sobha Realty", line: "red", lat: 25.0620, lng: 55.1330 },    // formerly Nakheel Harbour & Tower
  { name: "Ibn Battuta", line: "red", lat: 25.0470, lng: 55.1180 },
  { name: "Energy", line: "red", lat: 25.0350, lng: 55.1060 },
  { name: "Danube", line: "red", lat: 25.0250, lng: 55.0950 },
  { name: "UAE Exchange", line: "red", lat: 25.0180, lng: 55.0800 },
  { name: "Jebel Ali", line: "red", lat: 25.0090, lng: 55.0620 },
  { name: "The Gardens", line: "red", lat: 24.9950, lng: 55.0500 },
  { name: "Discovery Gardens", line: "red", lat: 24.9860, lng: 55.0420 },
  { name: "Al Furjan", line: "red", lat: 24.9780, lng: 55.0330 },
  { name: "Jumeirah Golf Estates", line: "red", lat: 24.9670, lng: 55.0220 },
  { name: "Dubai Investment Park", line: "red", lat: 24.9550, lng: 55.0100 },
  { name: "Expo City", line: "red", lat: 24.9600, lng: 55.1600 },       // formerly Expo 2020

  // ── Green Line (Etisalat by e& → Al Fahidi / Creek) ─────────────────
  { name: "Etisalat by e&", line: "green", lat: 25.2790, lng: 55.3670 }, // rebranded 2022
  { name: "Al Qusais", line: "green", lat: 25.2720, lng: 55.3520 },
  { name: "Dubai Airport Free Zone", line: "green", lat: 25.2700, lng: 55.3450 },
  { name: "Al Nahda", line: "green", lat: 25.2650, lng: 55.3300 },
  { name: "Stadium", line: "green", lat: 25.2708, lng: 55.3378 },
  { name: "Al Qiyadah", line: "green", lat: 25.2680, lng: 55.3200 },
  { name: "Abu Baker Al Siddique", line: "green", lat: 25.2660, lng: 55.3100 },
  { name: "Salahuddin", line: "green", lat: 25.2620, lng: 55.3050 },
  { name: "Union", line: "green", lat: 25.2545, lng: 55.3310 },
  { name: "Baniyas Square", line: "green", lat: 25.2620, lng: 55.3080 },
  { name: "Palm Deira", line: "green", lat: 25.2650, lng: 55.3020 },
  { name: "Al Ras", line: "green", lat: 25.2680, lng: 55.2970 },
  { name: "Al Ghubaiba", line: "green", lat: 25.2540, lng: 55.2955 },
  { name: "Sharaf DG", line: "green", lat: 25.2510, lng: 55.2985 },
  { name: "BurJuman", line: "green", lat: 25.2528, lng: 55.3325 },
  { name: "Oud Metha", line: "green", lat: 25.2440, lng: 55.3140 },
  { name: "Dubai Healthcare City", line: "green", lat: 25.2350, lng: 55.3210 },
  { name: "Al Jadaf", line: "green", lat: 25.2250, lng: 55.3320 },
  { name: "Creek", line: "green", lat: 25.2200, lng: 55.3390 },

  // Blue Line (opens Sep 2029, 14 stations - RTA announcement Sep 2024)
  { name: "Centrepoint (Blue)", line: "blue", lat: 25.2732, lng: 55.4058, future: true },
  { name: "Al Mizhar 1", line: "blue", lat: 25.2500, lng: 55.4300, future: true },
  { name: "Al Warqa'a", line: "blue", lat: 25.2350, lng: 55.4400, future: true },
  { name: "Mirdif Hills", line: "blue", lat: 25.2180, lng: 55.4340, future: true },
  { name: "Mirdif City Centre", line: "blue", lat: 25.2080, lng: 55.4160, future: true },
  { name: "International City 1", line: "blue", lat: 25.1690, lng: 55.4130, future: true },
  { name: "International City 2", line: "blue", lat: 25.1610, lng: 55.4210, future: true },
  { name: "Ras Al Khor", line: "blue", lat: 25.1830, lng: 55.3560, future: true },
  { name: "Dubai Silicon Oasis", line: "blue", lat: 25.1220, lng: 55.3800, future: true },
  { name: "Academic City 1", line: "blue", lat: 25.1130, lng: 55.4130, future: true },
  { name: "Academic City 2", line: "blue", lat: 25.1080, lng: 55.4300, future: true },
  { name: "Dubai Creek Harbour", line: "blue", lat: 25.1990, lng: 55.3510, future: true },
  { name: "Ras Al Khor Industrial", line: "blue", lat: 25.1720, lng: 55.3200, future: true },
  { name: "Emaar Beachfront (planned)", line: "blue", lat: 25.0900, lng: 55.1370, future: true },
];

// ── Dubai Tram (11 stations, ~10.6 km — RTA operational since 2014) ─────
// Route: Al Sufouh Rd → Dubai Marina → JBR, with two interchanges to the
// Red Line (Jumeirah Lakes Towers & DAMAC Properties via pedestrian bridge).
export const TRAM_STATIONS = [
  { name: "Al Sufouh", lat: 25.0995, lng: 55.1685 },
  { name: "Media City", lat: 25.0966, lng: 55.1610 },
  { name: "Palm Jumeirah", lat: 25.0965, lng: 55.1555 },
  { name: "Knowledge Village", lat: 25.0950, lng: 55.1480 },
  { name: "Mina Seyahi", lat: 25.0898, lng: 55.1440 },
  { name: "Dubai Marina Mall", lat: 25.0765, lng: 55.1400 },
  { name: "Marina Towers", lat: 25.0790, lng: 55.1385 },
  { name: "Jumeirah Beach Residence 1", lat: 25.0800, lng: 55.1350 },
  { name: "Jumeirah Beach Residence 2", lat: 25.0770, lng: 55.1325 },
  { name: "Jumeirah Lakes Towers", lat: 25.0700, lng: 55.1400 },   // interchange w/ Red
  { name: "DAMAC Properties", lat: 25.0850, lng: 55.1520 },        // interchange w/ Red
];

// ── Palm Jumeirah Monorail (4 stations, 5.4 km — Nakheel operated) ─────
// Runs from Palm Gateway (base of trunk) to Atlantis at the crescent tip.
export const MONORAIL_STATIONS = [
  { name: "Palm Gateway", lat: 25.1085, lng: 55.1420 },
  { name: "Al Ittihad Park", lat: 25.1180, lng: 55.1370 },
  { name: "Nakheel Mall", lat: 25.1130, lng: 55.1385 },
  { name: "Atlantis Aquaventure", lat: 25.1310, lng: 55.1170 },
];

// ── Etihad Rail Passenger Network (UAE-wide, launch expected 2026) ─────
// Nationwide high-speed line linking all 7 emirates. Route/coords approximate
// per Etihad Rail Sep-2024 announcement; final station names may vary.
export const ETIHAD_RAIL_STATIONS = [
  { name: "Abu Dhabi", lat: 24.4539, lng: 54.3773, future: true },
  { name: "Al Faya", lat: 24.7500, lng: 55.6900, future: true },
  { name: "Dubai (Al Maktoum)", lat: 25.1200, lng: 55.4300, future: true },
  { name: "Sharjah", lat: 25.3463, lng: 55.4209, future: true },
  { name: "Ajman", lat: 25.4111, lng: 55.4353, future: true },
  { name: "Umm Al Quwain", lat: 25.5647, lng: 55.5533, future: true },
  { name: "Ras Al Khaimah", lat: 25.8007, lng: 55.9762, future: true },
  { name: "Fujairah", lat: 25.1288, lng: 56.3265, future: true },
];
